<dw-feat-text-template-sender
  #textTemplateSender
  [type]="type"
  [entityId]="entity().id"
  [attachments]="attachments"
  [context]="context"
  [subContext]="subContext"
  [linkedEntities]="linkedEntities"
  [sendingAllowed]="sendByEmail()"
  (afterSend)="afterSend($event)"
>
  <div class="col col-md-2 d-flex align-items-end">
    <div class="form-check form-switch">
      <input
        id="sendByEmail"
        class="form-check-input"
        type="checkbox"
        role="switch"
        [(ngModel)]="sendByEmail"
      />
      <label for="sendByEmail" class="form-check-label text-primary">
        {{ 'Doc::SendByEmail' | abpLocalization }}
      </label>
    </div>
  </div>
  @if (isThirdPartyElligible()) {
    <div class="col col-md-2 d-flex align-items-end">
      <div class="form-check form-switch">
        @if (isPeppolConfigurationEnabled) {
          <input
            id="sendToPeppol"
            class="form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="sendToPeppol"
          />
          <label for="sendToPeppol" class="form-check-label text-primary">
            {{ 'Doc::SendToPeppol' | abpLocalization }}
          </label>
        } @else {
          <input
            id="generateUbl"
            class="form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="generateUbl"
          />
          <label for="generateUbl" class="form-check-label text-primary">
            {{ 'Doc::GenerateUbl' | abpLocalization }}
          </label>
        }
      </div>
    </div>
  }
</dw-feat-text-template-sender>
